import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import Table from 'react-bootstrap/Table';
import Pagination from 'react-js-pagination';

import {
    boPhanGetAllAction,
    boPhanDeleteAction
} from '@app/store/reducers/boPhan';
import { URI_INTERNAL } from '@app/utils/pathLocations';
import { toast } from 'react-toastify';
import { messageToast, objectShowNumber } from '@app/utils/define';
import { ConfirmModal } from '../../modules/modal/ConfirmModal';
import { Dropdown } from 'react-bootstrap';


const BoPhan = () => {
    const dispatch = useDispatch();
    const { list, loading } = useSelector((state) => state.boPhan);

    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);

    const [openConfirmDeleteModal, setOpenConfirmDeleteModal] = useState(false);
    const [idWantDelete, setIdWantDelete] = useState(null);
    const [confirmDelMessage, setConfirmDelMessage] = useState('');

    useEffect(() => {
        dispatch(boPhanGetAllAction());
    }, [dispatch]);

    const totalItems = list?.length || 0;
    const pagedData =
        list && list.length > 0
            ? list.slice((page - 1) * pageSize, page * pageSize)
            : [];

    const changePage = (number) => {
        setPage(number);
    };

    const onChangeShowNumber = (e) => {
        const newSize = parseInt(e.target.value, 10) || 20;
        setPageSize(newSize);
        setPage(1);
    };

    const handleDelete = (id, name) => {
        setIdWantDelete(id);
        setConfirmDelMessage(name);
        setOpenConfirmDeleteModal(true);
    };

    const acceptDelete = async () => {
        if (!idWantDelete) return;

        try {
            await dispatch(boPhanDeleteAction(idWantDelete)).unwrap();
            toast.success(messageToast.messageToastDeleteSuccess);
        } catch (err) {
            console.error('Xoá bộ phận lỗi:', err);

            let msg =
                (err && err.message) ||
                (typeof err === 'string' ? err : '') ||
                (err && err.title) ||
                '';

            if (!msg && err && err.errors) {
                msg = Object.values(err.errors).flat().join('; ');
            }

            toast.error(
                msg
                    ? `${messageToast.messageToastTryCatch}: ${msg}`
                    : messageToast.messageToastTryCatch
            );
        } finally {
            setOpenConfirmDeleteModal(false);
            setIdWantDelete(null);
            setConfirmDelMessage('');
        }
    };

    const cancelDelete = () => {
        setOpenConfirmDeleteModal(false);
        setIdWantDelete(null);
        setConfirmDelMessage('');
    };

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-lg-12">
                    <div className="card">
                        <div className="card-header">
                            <h3 className="card-title">Danh sách Bộ phận</h3>
                        </div>
                        <div className="card-body">
                            <div className="d-flex justify-content-between mb-2">
                                <form className="form-inline">
                                    <label className="mr-2">Hiển thị :</label>
                                    <select
                                        className="form-control"
                                        value={pageSize}
                                        onChange={onChangeShowNumber}
                                    >
                                        {objectShowNumber.map(
                                            (item, idx) => (
                                                <option
                                                    key={idx}
                                                    value={item.value}
                                                >
                                                    {item.text}
                                                </option>
                                            )
                                        )}
                                    </select>
                                </form>

                                <NavLink
                                    className="nav-link-reject nav-link"
                                    to={URI_INTERNAL.BOPHAN_CREATE_PATH}
                                >
                                    <button
                                        type="button"
                                        className="btn btn-info"
                                    >
                                        Thêm mới
                                    </button>
                                </NavLink>
                            </div>

                            {loading ? (
                                <div>Đang tải...</div>
                            ) : (
                                <>
                                    <Table striped bordered hover>
                                        <thead>
                                            <tr>
                                                <th>STT</th>
                                                <th>Mã bộ phận</th>
                                                <th>Tên bộ phận</th>
                                                <th>Chức năng</th>
                                            </tr>
                                        </thead>
                                        {pagedData && pagedData.length > 0 ? (
                                            <tbody>
                                                {pagedData.map(
                                                    (bp, index) => (
                                                        <tr key={bp.id}>
                                                            <td>
                                                                {index +
                                                                    1 +
                                                                    (page - 1) *
                                                                        pageSize}
                                                            </td>
                                                            <td>
                                                                {bp.maBoPhan}
                                                            </td>
                                                            <td>
                                                                {bp.tenBoPhan}
                                                            </td>
                                                            <td className="text-center" style={{ whiteSpace: 'nowrap' }}>
                                                                <div className="d-flex justify-content-center">
                                                                    <Dropdown align="end">
                                                                        <Dropdown.Toggle
                                                                            variant="outline-secondary"
                                                                            size="sm"
                                                                            id={`bophan-actions-${bp.id}`}
                                                                            className="d-inline-flex align-items-center justify-content-center"
                                                                            style={{ minWidth: 92, whiteSpace: 'nowrap' }}
                                                                        >
                                                                            Thao tác
                                                                        </Dropdown.Toggle>

                                                                        <Dropdown.Menu>
                                                                            <Dropdown.Item
                                                                                as={NavLink}
                                                                                to={`${URI_INTERNAL.BOPHAN_EDIT_PATH}?id=${bp.id}`}
                                                                                exact
                                                                            >
                                                                                Sửa
                                                                            </Dropdown.Item>

                                                                            <Dropdown.Divider />

                                                                            <Dropdown.Item
                                                                                as="button"
                                                                                className="w-100 text-left text-danger"
                                                                                onClick={(e) => {
                                                                                    e.preventDefault();
                                                                                    handleDelete(bp.id, bp.tenBoPhan);
                                                                                }}
                                                                            >
                                                                                Xóa
                                                                            </Dropdown.Item>
                                                                        </Dropdown.Menu>
                                                                    </Dropdown>
                                                                </div>
                                                            </td>

                                                        </tr>
                                                    )
                                                )}
                                            </tbody>
                                        ) : (
                                            <tbody>
                                                <tr className="txt-center">
                                                    <td colSpan="4">
                                                        Không có dữ liệu
                                                    </td>
                                                </tr>
                                            </tbody>
                                        )}
                                    </Table>

                                    <div className="dataTables_paginate paging_simple_numbers">
                                        <Pagination
                                            itemClass="page-item"
                                            linkClass="page-link"
                                            innerClass="pagination pagination-sm no-margin pull-right"
                                            activePage={page}
                                            itemsCountPerPage={Number(
                                                pageSize
                                            )}
                                            totalItemsCount={totalItems}
                                            pageRangeDisplayed={5}
                                            onChange={changePage}
                                        />
                                    </div>
                                </>
                            )}

                            <ConfirmModal
                                isOpen={openConfirmDeleteModal}
                                confirmType="delete"
                                handleAccept={acceptDelete}
                                handleCancel={cancelDelete}
                                content={confirmDelMessage}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BoPhan;
